import React from "react";
import { useTranslation } from "react-i18next";

import Button from "@mui/material/Button";
import ChecklistOutlinedIcon from "@mui/icons-material/ChecklistOutlined";

// Shared sticky footer button rendered on both the Tests tab and the
// General Waiver Request tab. Clicking it always opens the General Waiver
// Request form directly (never just the tab) — see onClick wiring at each
// call site in BridgeLoanResultTab.tsx / GeneralWaiverRequestTab.tsx.
export default function RequestGeneralWaiverFooter({
  onClick,
}: {
  onClick: () => void;
}) {
  const { t } = useTranslation();
  return (
    <div
      data-testid="general-waiver-sticky-footer"
      style={{
        position: "sticky",
        bottom: 0,
        display: "flex",
        justifyContent: "flex-end",
        padding: "12px 16px",
        marginTop: "12px",
        background: "#fff",
        borderTop: "1px solid #DBE2FF",
      }}
    >
      <Button
        variant="outlined"
        size="small"
        startIcon={<ChecklistOutlinedIcon fontSize="small" />}
        onClick={onClick}
        data-testid="request-general-waiver-button"
      >
        {t("requestGeneralWaiver")}
      </Button>
    </div>
  );
}
